import styled from 'styled-components'

export const CatalogItemDetailsCartActionsStyled = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
  width: 100%;

  > :first-child {
    flex: 1 1 0;
  }

  > :last-child {
    flex: 2 1 0;
  }
`
